import { render } from "./App.vue?vue&type=template&id=35797216"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35797216&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.35_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__